module.exports = __webpack_public_path__ + "sunsemweb/img/2.6f32581e.png";